import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common'
import { serviceURLService } from '../service/serviceURL';
import { environment } from '../../environments/environment';
import { WindowRef } from '../service/WindowRef.service';
import { proposalData } from './covid-proposal-data.model';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { from } from 'rxjs';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-covid-protection-proposal',
  templateUrl: './covid-protection-proposal.component.html',
  styleUrls: ['./covid-protection-proposal.component.css']
})
export class CovidProtectionProposalComponent implements OnInit {
  modalRef: BsModalRef;
  f: proposalData = new proposalData();
  thankyouSection: boolean = false;
  transactionFailureSection: boolean = false;
  loading: boolean;
  nomineeList: any;
  error: any;
  occupationList: any;
  occupationListMap: { 'key': string; 'value': {}; };
  listOfOccupation: any[];
  data: {};
  proposalData: {};
  cityStateList: any;
  pinCodeValue: any;
  cityList: any;
  stateList: any;
  fName: any;
  lName: any;
  regDate: any;
  PAQuoteId: string;
  proposalId: any;
  errorInternalMsg: any;
  errorStatus: any;
  ageDifference: number;
  shouldBe18: boolean;
  insuredShouldBe18: boolean;
  nomineeShouldBe18: boolean;
  DOBrequired: boolean;
  insuredDOBrequired: boolean;
  nomineeDOBrequired: boolean;
  invalidPincode: boolean;
  mobileNumber: string;
  public environment = environment;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  txnId: string = '';
  proposalFormDataForCovid: string;
  saveproposalFormResponseCovid: string;
  quoteIdForCovid: string;
  company: string;
  location: string;
  mobile: string;
  email: string;
  name: string;
  rzp1: any;
  secureNowTxnRefNo: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  //options for RazorPay
  options = {
    key: environment.covidRazorpayKey,
    //amount: this.savedTotalPremium, //  = INR 1
     name: 'Secure now',
     description: 'Purchase description',
     image: "https://pamstaging2.securenow.in/static/images/securenow_logo.svg",
     order_id: this.txnId,
    //  callback_url: 'https://www.google.com',
     handler: function (response){
      this.secureNowTxnRefNo = localStorage.getItem("secureNowTxnRefNo");
      this.transactionData = {
        "txnId": this.secureNowTxnRefNo,
        "razorpaySignature": response.razorpay_signature,
        "razorpayPaymentId": response.razorpay_payment_id
      }
      if (typeof response.razorpay_payment_id == 'undefined' ||  response.razorpay_payment_id < 1) {
        alert("error with payment Id "+response.razorpay_payment_id);
      } else {
        $.ajax({
          url: environment.msUrl+"/individual-insurance/api/v1/transaction/payment-acknowledge-razorpay?txnId="+this.secureNowTxnRefNo+"&razorpaySignature="+response.razorpay_signature+"&razorpayPaymentId="+response.razorpay_payment_id,
          type: "POST",
          data: this.transactionData,
          contentType: "application/json; charset=utf-8",
          success: function (data) {
              // console.log(data.message, data.success);
              
              location.href = '/covid-protection-transaction';
          },
          error: function(data){
            alert(data.message);
            location.href = '/';
          }
        })
      }
 
     },
     prefill: {

     },
     notes: {

     },
     theme: {
         color: "#005BAA"
     },
  };

  constructor(private serviceURLService: serviceURLService, private modalService: BsModalService, private winRef: WindowRef) { }

  ngOnInit() {
    this.getAutopopulatedData();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false});
  }

  getCityStateList(pinCode) {
    this.f.pincode = pinCode;
    this.loading = true;
    this.data = {
      "pincode": JSON.stringify(this.f.pincode)
    }
    this.serviceURLService.getCityStateList(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.cityStateList = successData.data;
      this.cityList = successData.data.cityList;
      this.f.state = successData.data.state;
      this.loading = false;

      if (this.cityList.length == 0) {
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.invalidPincode = true;
      }
      else {
        this.invalidPincode = false;
      }
    }, errorData => {
      console.log("Oops..!! city/state list not found");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  getAutopopulatedData(){
    setTimeout(() => {
      this.f.firstName = localStorage.getItem("name").split(" ")[0];
      this.f.lastName = localStorage.getItem("name").split(" ").slice(-2).join(' ');
      this.f.mobile = localStorage.getItem("mobileNumber");
      this.f.email = localStorage.getItem("email")
    }, 500);    
  }

  submitProposalFormData() { 
    this.quoteIdForCovid = localStorage.getItem("quoteIdForCovid");
    this.loading = true;
    this.proposalData = {
        "title": this.f.title,
        "proposerFirstName": this.f.firstName,
        "proposerLastName": this.f.lastName,
        "mobileNumber": this.f.mobile,
        "emailID": this.f.email,
        "proposerGender": this.f.gender,
        "addressLine1": this.f.address1,
        "addressLine2": "",
        "pinCode": this.f.pincode,
        "city": this.f.city,
        "state": this.f.state,
        "insurerFirstName": this.f.insuredFirstName,
        "insurerLastName": this.f.insuredLastName,
        "insurerDateOfBirth": this.f.insuredDob,
        "insurerGender": this.f.insuredGender,
        "insurerRelationshipWithProposer": this.f.insuredRelation,
        "nomineeName": this.f.nomineeName,
        "nomineeDateOfBirth": this.f.nomineeDob,
        "nomineeRelationshipWithProposer": this.f.nomineeRelation,
        "purschaseOfPolicyAgreed": true,
        "agreedNoPreExistingCovidRelatedDisease": true,
        "agreedNoForeignTripInLast45Days": true,
        "agreedNotLivingWithAnExistingCovidPatient": true,
        "quoteId": localStorage.getItem("quoteIdForCovid")
    }
    this.serviceURLService.saveProposalDataForCovid(this.proposalData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.saveproposalFormResponseCovid = successData.data;
      
      this.initiatePaymentForCovid();
    }, errorData => {
      console.log("Oops..!! there is some error save proposal form");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  initiatePaymentForCovid() {
    // console.log("in initiate payment generali ",loi)
    this.loading = true;
    this.data = {
      insurer: "Reliance General Insurance Company Limited",
      option: '',
      quoteId: this.quoteIdForCovid
    }
    this.serviceURLService.initiatePaymentForCovid(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;

      this.txnId = successData.data.transactionId;
      localStorage.setItem("secureNowTxnRefNo", successData.data.secureNowTxnRefNo)
      // localStorage.setItem("LOI", loi)
      // console.log("successData txnId ",this.txnId);
      this.initPay();

    }, errorData => {
      console.log("Oops..!! Error");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }
  
  initPay(){
    // console.log("intipay txnId ",this.txnId);
    this.options.order_id =  this.txnId;
      this.rzp1 = new this.winRef.nativeWindow.Razorpay(this.options);
      this.rzp1.open();
  }

  calculateAge() { 
    this.DOBrequired = false;
    var regesterDate = new Date(this.f.dob);
    var ageDifMs = Date.now() - regesterDate.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    this.ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
      if(this.ageDifference < 18){
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.shouldBe18= true;
      }else{
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        this.shouldBe18= false;
      }
    
  }

  calculateAgeInsured() {
    this.insuredDOBrequired = false;
    var regesterDate = new Date(this.f.insuredDob);
    var ageDifMs = Date.now() - regesterDate.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    this.ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
      if(this.ageDifference < 18){
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.insuredShouldBe18= true;
      }else{
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        this.insuredShouldBe18= false;
      }
  }

  calculateAgeNominee() {
    this.nomineeDOBrequired = false;
    var regesterDate = new Date(this.f.nomineeDob);
    var ageDifMs = Date.now() - regesterDate.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    this.ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
      if(this.ageDifference < 18){
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.nomineeShouldBe18= true;
      }else{
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        this.nomineeShouldBe18= false;
      }
  }

  checkValue(){
    if(!this.f.dob){
      this.DOBrequired= true;
    }
  }

  checkValueInsured(){
    if(!this.f.insuredDob){
      this.insuredDOBrequired= true;
    }
  }

  checkValueNominee(){
    if(!this.f.nomineeDob){
      this.nomineeDOBrequired= true;
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
}
